/* eslint-disable */
import "@/assets/styles/index.scss";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
// import i18n from './config/i18n';
import "./components";
import "./global";

Vue.config.productionTip = false;

window.vm = new Vue({
    router,
    store,
    // i18n,
    render: (h) => h(App),
    mounted() {},
}).$mount("#app");
